import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Form from './Components/User/FormData';
import EditForm from './Components/Admin/EditForm';
import OldResurveyList from './Components/Admin/Oldresurveylist';
import NewResurveyList from './Components/Admin/Newresurveylist';
import AllList from './Components/Admin/Alllist';
import AdminLayout from './Components/Admin/AdminLayout'; // Import the layout


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Form />} />
        <Route path="/edit-form" element={<EditForm />} />

        {/* Wrap admin routes with the AdminLayout */}
        <Route path="/admin" element={<AdminLayout />}>
          {/* Default route for /admin */}
          <Route index element={<OldResurveyList />} />

          <Route path="oldresurveylist" element={<OldResurveyList />} />
          <Route path="newresurveylist" element={<NewResurveyList />} />
          <Route path="alllist" element={<AllList/>} />

    
        </Route>

        {/* Redirect to /admin if /admin/* paths don't match */}
        <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </Router>
  );
}

export default App;